<template>
    <v-navigation-drawer
        v-model="drawer"          
        width="400"
        app
        temporary
        right
        class="wost-drawer"
    >
        <div class="navigation-head">
            <span>{{ titleForm }}</span>                         
        </div>

        <div class="pl-3 pt-3 pr-3" style="height: 80vh;">                
            <template>
                <v-row>
                    <v-col cols="12">
                        <v-autocomplete
                            ref="brand_id"
                            v-model="typeForm.brand_id"
                            :items="brands"
                            label="Seleccione marca"
                            outlined
                            :item-text="customText"
                            item-value="id"
                            clearable
                            :rules="[() => !!typeForm.brand_id || 'Es necesario ingresar seleccionar una marca']"
                            hide-details="auto"
                            required
                        ></v-autocomplete>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            ref="name"
                            v-model="typeForm.name" 
                            label="Nombre" 
                            outlined 
                            :rules="[() => !!typeForm.name || 'Es necesario ingresar un nombre']"
                            hide-details="auto"
                            required
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-textarea
                            v-model="typeForm.description"
                            outlined
                            label="Descripción"
                            >
                        </v-textarea>
                    </v-col>
                </v-row>                
            </template>                    
        </div>

        <div class="mt-3 pl-3 pt-3 pr-3">
            <template>
                <v-row>
                    <v-col cols="6">
                        <v-btn block height="40" dark color="red" @click="handleCancel">
                            <v-icon class="mr-1" size="16">far fa-times-circle</v-icon>
                            Cancelar
                        </v-btn>
                    </v-col>
                    <v-col cols="6">
                        <v-btn v-if="action == 'create'" dark color="success" block height="40" @click="handleStore">
                            <v-icon class="mr-1" size="16">far fa-save</v-icon>
                            Guardar
                        </v-btn>
                        <v-btn v-if="action == 'update'" dark color="success" block height="40" @click="handleUpdate">
                            <v-icon class="mr-1" size="16">far fa-save</v-icon>
                            Actualizar
                        </v-btn>
                    </v-col>
                </v-row>
            </template>               
            
        </div>

    </v-navigation-drawer>
</template>

<script>
import { mapState, mapActions} from 'vuex'

export default {
    name: 'CreateUpdate',
    data() {
        return {
            drawer: false,
            titleForm: null,
            action: null,
            typeForm: {
                id: null,
                name: null,
                description: null,
                brand_id: null
            }
        }
    },
    computed: {
        ...mapState('brands', [
            'brands'
        ])
    },
    methods: {
        ...mapActions('brands', [
            'getBrands',
        ]),
        ...mapActions('types', [
            'store',
            'update'
        ]),
        async showForm(title, action, type = null) {
            await this.clearData();
            this.titleForm = title
            this.action = action
            if (type) {
                this.setType(type)
            }
            this.drawer = !this.drawer
        },
        clearData() {
            this.titleForm = null
            this.action = null
            this.typeForm.id = null
            this.typeForm.name = null
            this.typeForm.description = null
            this.typeForm.brand_id = null
            this.clearErrors();
        },
        setType(type) {
            this.typeForm.id = type.id
            this.typeForm.name = type.name
            this.typeForm.description = type.description
            this.typeForm.brand_id = type.brand_id
        },
        closeForm() {
            this.clearData()
            this.drawer = false
        },
        handleCancel() {
            this.closeForm()
        },
        customText(item){
            let text = item.name
            
            return text
        },
        async handleStore() {
            if (!this.existErrors()) {
                await this.store(this.typeForm)
                this.closeForm()
            }            
        },
        async handleUpdate() {
            if (!this.existErrors()) {
                await this.update(this.typeForm)
                this.closeForm()
            }            
        },
        existErrors(){
            let hasErrors = false;

            Object.keys(this.typeForm).forEach(f => {                
                if (this.$refs[f]) {
                    if (!this.typeForm[f]) hasErrors = true
                    this.$refs[f].validate(true);
                }                
            });

            return hasErrors;
        },
        clearErrors() {
            Object.keys(this.typeForm).forEach(f => {
                if (this.$refs[f]) this.$refs[f].reset()                
            });
        },
    },
    mounted() {
        this.getBrands()
    }
}
</script>

<style scoped>

</style>